<template>
	<div class="print__container">
		<div class="print__header">
			<h2>Print Matches</h2>
			<p class="print__header__description">
				Get a printable snapshot of your favourite matches and jackpots
			</p>
		</div>
		<ul class="print__tabs">
			<li
				class="print__tabs__item"
				:class="{ 'active ': isActive('fixtures') }"
			>
				<a
					class="print__tabs__link"
					@click.prevent="setActive('fixtures')"
					href="#fixtures"
					>Fixtures</a
				>
			</li>
			<li
				class="print__tabs__item"
				:class="{ 'active ': isActive('jackpots') }"
			>
				<a
					class="print__tabs__link"
					@click.prevent="setActive('jackpots')"
					href="#jackpots"
					>Jackpots</a
				>
			</li>
		</ul>
		<div class="print__tabs__content">
			<div class="print__tabs__pane" v-if="isActive('fixtures')" id="fixtures">
				<div class="print__tabs__container">
					<div class="print__tabs__buttons">
						<div
							class="print__tabs__button__container"
							@click="printCustom('-1')"
						>
							<download-loader
								v-if="printLoading && currentPrintingTab == '-1'"
							/>
							<div class="print__tabs__button__content">
								<span class="tr">
									<download-icon />
								</span>
								<span class="tl">
									<todays-icon />
								</span>
								<span class="tl" style="font-weight: 700">Today's</span>
								<span class="tl">Soccer Fixtures</span>
							</div>
						</div>
						<div
							class="print__tabs__button__container"
							@click="printCustom('1')"
						>
							<download-loader
								v-if="printLoading && currentPrintingTab == '1'"
							/>
							<div class="print__tabs__button__content">
								<span class="tr">
									<download-icon />
								</span>
								<span class="tl">
									<calendar-icon />
								</span>
								<span class="tl" style="font-weight: 700">Tomorrow's</span>
								<span class="tl">Soccer Fixtures</span>
							</div>
						</div>
						<div
							class="print__tabs__button__container"
							@click="printCustom('8')"
						>
							<download-loader
								v-if="printLoading && currentPrintingTab == '8'"
							/>
							<div class="print__tabs__button__content">
								<span class="tr">
									<download-icon />
								</span>
								<span class="tl">
									<calendar-icon />
								</span>
								<span class="tl" style="font-weight: 700">Next Week's</span>
								<span class="tl">Soccer Fixtures</span>
							</div>
						</div>
					</div>
					<div class="print__filters">
						<h3 class="print__filters__title">Download Custom Fixtures</h3>
						<div class="print__filters__container">
							<div class="print__filter">
								<span class="print__select__text">Select League</span>
								<div
									class="print__select"
									@click.stop="toggleDropdown('tagDropdown')"
								>
									<span class="print__select__title"
										>{{ selectedTag.tag_title }}
									</span>
									<div
										class="print__select__dropdown"
										v-show="isDropdownOpen('tagDropdown')"
									>
										<div
											class="print__select__dropdown__item"
											v-for="tag in tags"
											:key="tag.tag_id"
											@click="filterTags(tag)"
										>
											{{ tag.tag_title }}
										</div>
									</div>
								</div>
							</div>
							<div class="print__filter">
								<span class="print__select__text">Select Period</span>
								<div
									class="print__select"
									@click.stop="toggleDropdown('tabDropdown')"
								>
									<span class="print__select__title"
										>{{ currentTab.name }}
									</span>
									<div
										class="print__select__dropdown"
										v-show="isDropdownOpen('tabDropdown')"
									>
										<div
											class="print__select__dropdown__item"
											v-for="tab in tabs"
											:key="tab.id"
											@click="filterTabs(tab)"
										>
											{{ tab.name }}
										</div>
									</div>
								</div>
							</div>
							<div class="print__filter">
								<span class="print__select__text">No of Matches</span>
								<div
									class="print__select"
									@click.stop="toggleDropdown('limitDropdown')"
								>
									<span class="print__select__title"
										>{{ currentLimit }} Matches</span
									>
									<div
										class="print__select__dropdown"
										v-show="isDropdownOpen('limitDropdown')"
									>
										<div
											class="print__select__dropdown__item"
											v-for="(limit, index) in limits"
											:key="index"
											@click="filterLimits(limit)"
										>
											{{ limit }} Matches
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="print__filters__button__container">
							<b-button
								class="print__filters__button button button__secondary"
								@click="savePDF"
								:loading="printLoading"
								:disabled="printLoading"
								:title="'Download'"
							/>
						</div>
					</div>
				</div>
			</div>
			<div class="print__tabs__pane" v-if="isActive('jackpots')" id="jackpots">
				<div class="print__tabs__container">
					<span v-if="events.length == 0">
						There are currently no Active Jackpots. Please check back later
					</span>
					<div class="print__tabs__buttons">
						<div
							class="print__tabs__button__container"
							v-for="event in events"
							:key="event.id"
							@click="printJackpot(event.id)"
						>
							<download-loader
								v-if="printLoading && currentPrintingTab == event.id"
							/>
							<div class="print__tabs__button__content">
								<span class="tr">
									<download-icon />
								</span>
								<span class="tl">
									<grand-jackpot-image v-if="event.product_id == 6" />
									<midweek-jackpot-image v-if="event.product_id == 8" />
								</span>
								<span v-if="event.product_id == 8" class="tl"
									><span style="font-weight: 700">Betika Grand</span> <br />
									<span class="tl">Jackpot</span>
								</span>
								<span v-if="event.product_id == 6" class="tl"
									><span style="font-weight: 700">15M Midweek</span> <br />
									<span class="tl">Jackpot</span>
								</span>
							</div>
						</div>
					</div>
					<div class="print__filters">
						<h3 class="print__filters__title">Jackpot Results</h3>
						<div class="print__jpresults__container">
							<div
								class="print__jpresult"
								v-for="event in results"
								:key="event.id"
								@click="printJackpot(event.id, (isResults = true))"
							>
								<download-loader
									v-if="printLoading && currentPrintingTab == event.id"
								/>
								<div class="print__jpresult__image">
									<grand-jackpot-image v-if="event.product_id == 6" />
									<midweek-jackpot-image v-if="event.product_id == 8" />
								</div>
								<div class="print__jpresult__content">
									<div class="print__jpresult__text tl">
										<p>{{ event.event_name }}</p>
										<small
											>Ended on
											{{
												event.event_expiry | timeFormat("DD/MM HH:mm")
											}}</small
										>
									</div>
									<download-icon />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CalendarIcon from "./CalendarIcon.vue";
import DownloadIcon from "./DownloadIcon.vue";
import DownloadLoader from "./DownloadLoader.vue";
import GrandJackpotImage from "./GrandJackpotIcon.vue";
import MidweekJackpotImage from "./MidweekJackpotIcon.vue";
import TodaysIcon from "./TodaysIcon.vue";

export default {
	name: "DownloadFixtures",
	components: {
		DownloadLoader,
		MidweekJackpotImage,
		GrandJackpotImage,
		DownloadIcon,
		TodaysIcon,
		CalendarIcon,
	},
	props: {
		CalendarIconhow: Boolean,
	},
	data() {
		return {
			printLoading: false,
			sports: [],
			tabs: [],
			tags: [],
			markets: [],
			page: 1,
			dropdowns: {
				tabDropdown: { open: false },
				tagDropdown: { open: false },
				sportDropdown: { open: false },
				limitDropdown: { open: false },
				marketDropdown: { open: false },
			},
			limits: [50, 100, 150, 200],
			currentLimit: 100,
			currentTab: { id: -1, name: "Today's Highlights" },
			currentSport: { sport_id: 14, sport_name: "Football" },
			selectedTag: { tag_id: "", tag_title: "All Leagues" },
			selectedMarket: { name: "3 Way/2 Way", sub_type_id: "1" },
			selectedNavTab: "matches",
			results: [],
			events: [],
			activeTab: "fixtures",
			currentPrintingTab: "",
		};
	},
	mounted() {
		this.getFilters();
		this.getEvents();
		this.getResults();
	},
	methods: {
		isActive(tab) {
			return this.activeTab === tab;
		},
		setActive(tab) {
			this.activeTab = tab;
		},
		close() {
			this.$emit("close");
		},
		toggleDropdown(dropdown) {
			this.$set(
				this.dropdowns[dropdown],
				"open",
				!this.dropdowns[dropdown]["open"]
			);
		},
		isDropdownOpen(dropdown) {
			return this.dropdowns[dropdown]["open"];
		},
		getFilters() {
			let vm = this;
			let payload = {
				page: 1,
				limit: 1,
				sport_id: vm.currentSport.sport_id,
				tab_id: vm.currentTab.id,
				tag_id: vm.selectedTag.tag_id,
			};
			this.$http
				.get(`${BASE_URL}uo/matches`, { params: payload })
				.then((response) => {
					vm.tabs = response.data.meta ? response.data.meta.tabs : [];
					vm.sports = response.data.meta ? response.data.meta.sports : [];
					const nullTag = [{ tag_id: "", tag_title: "All Leagues" }];
					vm.tags = [...nullTag, ...response.data.meta.tags];
					vm.markets = response.data.meta ? response.data.meta.filters : [];
				})
				.catch((err) => {});
		},
		getEvents() {
			this.$http
				.get(`${BASE_URL}jackpot/events`)
				.then((response) => {
					this.events = response.data;
				})
				.catch((error) => {
					console.error(error);
				});
		},
		getResults() {
			let vm = this;
			vm.$http
				.get(`${BASE_URL}jackpot/previous`)
				.then((response) => {
					vm.results = response.data;
				})
				.catch((error) => {
					console.log("Error getting results: ", error);
				});
		},
		filterTags(tag) {
			let vm = this;
			vm.selectedTag = tag;
			let upcoming = { id: -2, name: "🔥 Next 48Hrs" };
			vm.currentTab = upcoming;
			vm.getFilters();
		},
		filter() {
			this.getFilters();
		},
		filterSport(sport) {
			let vm = this;
			vm.currentSport = sport;
			vm.getFilters();
		},
		filterTabs(tab) {
			let vm = this;
			vm.currentTab = tab;
		},
		filterMarkets(market) {
			let vm = this;
			vm.selectedMarket = market;
		},
		filterLimits(limit) {
			let vm = this;
			vm.currentLimit = limit;
		},
		pushDataLayer(printType) {
			this.$tracking.general.printMatches(printType);
		},

		printJackpot(eventID, isResults = false) {
			let vm = this;
			let params = {
				jackpotId: eventID,
				isResults: isResults,
			};
			this.printLoading = true;
			this.currentPrintingTab = eventID;
			this.$http
				.get(`${this.env.printApiUrl}print-jackpots`, {
					params: params,
					responseType: "arraybuffer",
					headers: {
						Accept: "application/pdf",
					},
				})
				.then((response) => {
					let milis = new Date();
					milis = milis.getTime();
					const blob = new Blob([response.data], { type: "application/pdf" });
					const link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.download = `${eventID}-${milis}.pdf`;
					link.click();
					this.printLoading = false;
					this.pushDataLayer("printJackpotSuccess");
				})
				.catch((err) => {
					this.printLoading = false;
				});
		},
		printCustom(tabID) {
			let vm = this;
			let params = {
				page: 1,
				limit: 100,
				tab: tabID,
				sport_id: "14",
				tag_id: "",
			};
			this.printLoading = true;
			this.currentPrintingTab = tabID;
			this.$http
				.get(`${this.env.printApiUrl}print-pdf`, {
					params: params,
					responseType: "arraybuffer",
					headers: {
						Accept: "application/pdf",
					},
				})
				.then((response) => {
					let milis = new Date();
					milis = milis.getTime();
					const blob = new Blob([response.data], { type: "application/pdf" });
					const link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.download = `${this.currentSport.sport_name}-${milis}.pdf`;
					link.click();
					this.printLoading = false;
					this.pushDataLayer("printCustomSuccess");
				})
				.catch((err) => {
					this.printLoading = false;
				});
		},
		getPDF() {
			let vm = this;
			let params = {
				page: vm.page,
				limit: vm.currentLimit,
				tab: vm.currentTab.id,
				sub_type_id: vm.selectedMarket.sub_type_id,
				sport_id: vm.currentSport.sport_id,
				tag_id: vm.selectedTag.tag_id,
			};
			return this.$http.get(`${this.env.printApiUrl}print-pdf`, {
				params: params,
				responseType: "arraybuffer",
				headers: {
					Accept: "application/pdf",
				},
			});
		},
		savePDF() {
			this.printLoading = true;
			return this.getPDF()
				.then((response) => {
					let milis = new Date();
					milis = milis.getTime();
					const blob = new Blob([response.data], { type: "application/pdf" });
					const link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.download = `${this.currentSport.sport_name}-${milis}.pdf`;
					link.click();
					this.printLoading = false;
					this.pushDataLayer("printDefaultSuccess");
				})
				.catch((err) => {
					this.printLoading = false;
				});
		},
	},
};
</script>

<style lang="scss">
.tc {
	text-align: center;
}
.tr {
	text-align: right;
}
.tl {
	text-align: left;
}

.print {
	&__container {
		display: flex;
		flex-direction: column;
		background: var(--white);
		padding: 30px;
	}
	&__header {
		width: 100%;
		&__description {
			text-align: left;
			margin: 0;
		}
		&__top {
			display: flex;
			justify-content: space-between;
			align-items: center;
			color: var(--light-black);
			span {
				font-size: var(--font-largest);
				font-weight: var(--font-weight-bold);
				cursor: pointer;
			}
		}
	}
	&__jpresults {
		&__container {
			display: flex;
			flex-direction: column;
		}
	}
	&__jpresult {
		position: relative;
		display: flex;
		align-items: center;
		width: 55%;
		color: var(--green);
		margin-bottom: 10px;
		border-radius: 4px;
		box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.2);
		border: 1px solid var(--lightest-blue);
		padding: 8px 20px;
		cursor: pointer;
		&:hover {
			background: var(--light-green);
		}
		&__content {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
		}
		&__image {
			margin-right: 12px;
		}
		&__text {
			line-height: 1.2;
			p {
				margin: 0;
				font-size: var(--font-normal);
				font-weight: var(--font-weight-bold);
			}
		}
	}
	&__tabs {
		display: flex;
		padding: 15px 0;
		&__buttons {
			display: flex;
			margin-bottom: 20px;
		}
		&__button {
			&__container {
				position: relative;
				padding: 15px 10px;
				margin-right: 20px;
				font-size: var(--font-normal);
				width: 19%;
				line-height: 1.7;
				color: var(--green);
				border-radius: 4px;
				box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.2);
				cursor: pointer;
				border: 1px solid var(--lightest-blue);
				&:hover {
					background: var(--light-green);
				}
			}
			&__content {
				display: flex;
				flex-direction: column;
			}
		}
		&__item {
			list-style: none;
			padding: 10px 0;
			margin-right: 15px;
			&.active {
				border-bottom: 2px solid var(--black);
			}
		}
		&__link {
			text-decoration: none;
			font-size: 15px;
			font-weight: 700;
			color: var(--black);
		}
		&__overlay {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.9);
			opacity: 0.8;
			border-radius: 4px;
		}
	}
	&__filters {
		margin-top: 50px;
		&__button {
			background-color: var(--green);
			color: var(--always-white);
			font-size: var(--font-normal);
			font-weight: var(--font-weight-bold);
			padding: 10px 25px;
			border: 0;
			border-radius: 8px;
			cursor: pointer;
			transition: 0.2ms ease-in-out opacity;
			&:hover {
				opacity: 0.9;
			}
			&__container {
				display: flex;
				align-items: flex-start;
			}
		}
		&__container {
			display: flex;
		}
		&__title {
			text-align: left;
			color: var(--light-black);
		}
	}
	&__filter {
		display: flex;
		flex-direction: column;
		width: 30%;
		margin-bottom: 20px;
		margin-right: 15px;
		justify-content: flex-start;
		align-items: flex-start;
	}
	&__select {
		text-align: left;
		width: 90%;
		display: flex;
		align-items: center;
		border: 0;
		font-weight: var(--font-weight-normal);
		height: 35px;
		padding-right: 25px;
		font-size: var(--font-normal);
		appearance: none;
		background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAGCAYAAAAVMmT4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACSSURBVHgBhYwtDoNAFITfsNdoEzyqjiYVxVVWcoyS9AJ1FW2C7AlablHFjySBA5BgwIFnd+GJTRAQRs18mRm4/s0WEH8QbFoTdDcoebCyKKyklh6DtaIi6XHP4syGwdJAKR0k3zBnLwysi6zZOccWwNUwTRQk0ftjspi/1GWa7x23nwYXAj3i3+tJWzr59/MSHwEs3TX/zp2ZUQAAAABJRU5ErkJggg==);
		background-repeat: no-repeat;
		background-position: 95% center;
		position: relative;
		transition: all 0.2s ease-in-out;
		cursor: pointer;
		background-color: var(--light-blue);
		border-radius: 8px;
		&__text {
			margin-bottom: 5px;
			text-align: left;
			font-weight: var(--font-weight-normal);
			font-size: var(--font-small);
			color: var(--light-black);
		}
		&__title {
			font-weight: var(--font-weight-normal);
			padding-left: 10px;
			color: var(--black);
		}
		&__dropdown {
			z-index: 99;
			display: block;
			position: absolute;
			left: 0;
			top: 110%;
			min-width: 155px;
			width: max-content;
			background-color: var(--white);
			color: var(--light-black);
			border: 1px solid var(--lightest-blue);
			border-radius: 4px;
			box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);
			max-height: 25vh;
			overflow: auto;
			&__item {
				padding: 10px 15px;
				border-bottom: 1px solid var(--lightest-blue);
				cursor: pointer;
				&:hover {
					background: var(--light-blue);
				}
			}
		}
	}
}
</style>
